// extracted by mini-css-extract-plugin
export default {"main":"layoutLogin_main__D6hl7","bigLogo":"layoutLogin_bigLogo__OdFsA"};